import React, {FC} from "react";
import {useWorker} from "../../workers/redux/workers.hook";
import {AuthContext} from "../../../auth/components/AuthProvider";
import {Button, Snackbar} from "@material-ui/core";
import {Alert, AlertTitle} from "@material-ui/lab";
import {useServices} from "../../services/redux/services.hook";
import {useHistory} from "react-router-dom";

export const NoServicesAlert: FC = () => {

    const history = useHistory();

    const closeSnackbar = () => {
        history.push("/worker/personal-data")
    };

    const services = useServices();

    const activeServices = services.filter(s => s.active).map(s => s.id);

    const {userId} = React.useContext(AuthContext);
    const {worker} = useWorker(userId);

    const open = worker && (worker.servicesIds.every(s => !activeServices.includes(s)));

    return (
        <Snackbar
            anchorOrigin={{horizontal: "center", vertical: "top"}}
            open={open}
        >
            <Alert
                severity="warning"
                action={
                    <Button onClick={closeSnackbar} size="small" color="inherit">Jetzt eintragen</Button>
                }
            >
                <AlertTitle>Keine Dienstleistung</AlertTitle>
                Bitte wähle Dienstleistungen aus, damit du gebucht werden kannst.
            </Alert>
        </Snackbar>
    )
}
